// extracted by mini-css-extract-plugin
export var bullet = "_mb-q";
export var bulletText = "_mb-p";
export var bullets = "_mb-k";
export var callout = "_mb-g";
export var calloutBody = "_mb-i";
export var calloutLabel = "_mb-h";
export var checkIcon = "_mb-m";
export var checkList = "_mb-j";
export var checkSvg = "_mb-n";
export var checkText = "_mb-o";
export var fieldCard = "_mb-1";
export var fieldDescription = "_mb-5";
export var fieldHeader = "_mb-3";
export var fieldTitle = "_mb-4";
export var finalNote = "_mb-s";
export var flow = "_mb-x";
export var flowArrow = "_mb-v";
export var flowStep = "_mb-u";
export var helperText = "_mb-r";
export var inlineTitle = "_mb-t";
export var listItem = "_mb-l";
export var noteBody = "_mb-8";
export var noteBodyText = "_mb-9";
export var noteCard = "_mb-2";
export var noteIcon = "_mb-6";
export var noteTitle = "_mb-7";
export var productChoices = "_mb-w";
export var radioDot = "_mb-d";
export var radioDotSelected = "_mb-e";
export var radioDotSvg = "_mb-f";
export var selectableCard = "_mb-b";
export var selectableCardSelected = "_mb-c";
export var strongText = "_mb-a";
export var subHeading = "_mb-0";